'use client';

import { PageBanner } from '@repo-ui/components/PageBanner';
import { routerPushI18n } from '@repo-ui/router';
import { useLocale } from 'next-intl';

const BANNER_TINT = '#DD7CED';
const BANNER_BACKGROUND = '#121212';

const BANNER_TABS = [
  { key: 'list', label: '강좌 목록' },
  { key: 'chim', label: '관심 강좌' },
  { key: 'mine', label: '나의 강좌' },
] as const;

export type BannerTabKey = (typeof BANNER_TABS)[number]['key'];

interface Props {
  tabKey?: BannerTabKey;
}

export function OpenLecturePageBanner(props: Props) {
  const { tabKey = 'list' } = props;
  const locale = useLocale();

  return (
    <PageBanner
      className="OpenLecturePageBanner-root"
      title="오픈강좌"
      tint={BANNER_TINT}
      contrastColor="#222"
      background={BANNER_BACKGROUND}
      bgImgSrc="/_static/images/page-banner/top_banner7.png"
      tabKey={tabKey}
      tabs={BANNER_TABS}
      breadcrumbProps={{
        tint: '#fff',
        section: '커뮤니티',
        currentTitle: '오픈강좌',
      }}
      onChangeTab={(_, value) => {
        routerPushI18n('/openlecture', value);
      }}
    />
  );
}
